"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 25",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.44 10.45h-4.764a.311.311 0 0 1-.302-.393L14.867.795A.312.312 0 0 0 14.31.54L5.246 13.88a.312.312 0 0 0 .255.48h4.755a.313.313 0 0 1 .302.395L8.065 24.03a.312.312 0 0 0 .557.255l9.088-13.34a.312.312 0 0 0-.27-.495Z"
  })]
});